export default "__VITE_ASSET__C4lhD8xe__"